const screenTypes = {
  BOOT: 'BOOT',
  HOME: 'HOME',
  RUN: 'RUN',
  HELP: 'HELP',
  CODE: 'CODE',
  SPRITE: 'SPRITE',
  MAP: 'MAP',
  SONG: 'SONG',
  CHAIN: 'CHAIN',
  PHRASE: 'PHRASE',
  SHELF: 'SHELF'
}

export default screenTypes



// WEBPACK FOOTER //
// ./src/utils/screenTypes.js